import { createSelector } from "reselect";

const filterTimeCarousel = {
  open: {
    "00:01:00": 4 * 60 * 1000,
    "00:05:00": 900000,
    "00:15:00": 2700000,
    "01:00:00": 10800000,
    "1.00:00:00": 259200000,
  },
  closed: {
    "00:01:00": -240000,
    "00:05:00": -1200000,
    "00:15:00": -35000000,
    "01:00:00": -14400000,
    "1.00:00:00": -259200000,
  },
};

export const contestsFromRoot = (state: any) => state?.contestSeries;

export const getSelectedCoin = createSelector(
  contestsFromRoot,
  ({ view }) => view.selectedCoins?.[0] || "BTC"
);
export const getSelectedDuration = createSelector(
  contestsFromRoot,
  () => "00:01:00"
);

export const getStatusFetched = (state: any) =>
  state?.contestSeries?.series?.isFetched || true;

export const getContestsStore = createSelector(
  (state: any) => contestsFromRoot(state),
  (contestSeries) => {
    const seriesKey = `${"00:01:00"}-${"USDC"}-${"BTC"}`;
    const contestsDisplay = (contestSeries.series[seriesKey] || [])
      .map((contestId: string) => {
        const contest = contestSeries.contests[contestId];
        return contest;
      })
      .filter((contest: any) => {
        if (!contest) {
          return false;
        }
        const timeFromLive = Date.parse(contest.contestLiveTime) - Date.now();

        if (contest.status !== "Closed") {
          return timeFromLive < filterTimeCarousel.open["00:01:00"];
        } else {
          return timeFromLive > filterTimeCarousel.closed["00:01:00"];
        }
      })
      .sort((a: any, b: any) => {
        const aTime: any = new Date(a.contestLiveTime);
        const bTime: any = new Date(b.contestLiveTime);

        if (
          b.status === "GoingLive" &&
          (a.status === "Live" || a.status === "Opened")
        ) {
          return 1;
        }
        if (b.status === "Live" && a.status === "Opened") {
          return 1;
        }
        if (a.status && b.status === "Live") {
          const aTime: any = new Date(a.contestLiveTime);
          const bTime: any = new Date(b.contestLiveTime);
          return aTime - bTime;
        }
        return aTime - bTime;
      });

    return contestsDisplay;
  }
);

const getSortedContests = (
  selectedDuration,
  selectedCoin,
  lastPrices: any,
  contestSeries: any
) => {
  const seriesKey = `${selectedDuration}-USDC-${selectedCoin}`;
  const lastPrice = lastPrices?.[`${selectedCoin}`] || {};

  const seriesID = sessionStorage.getItem("seriesID");

  return (contestSeries.series[seriesKey] || [])
    .map((contestId) => {
      const now = Date.now();
      const playedContest = contestSeries.contestPlayed[contestId];
      // const playedContest = { id: contestId, entryId: 'any', wager: 100, position: Math.random() > 0.5 ? 'rekt' : 'moon' };
      // const playedContest = { id: contestId, entryId: 'any', wager: 100, position: 'rekt'};
      const contest = contestSeries.contests[contestId];

      if (contest && playedContest) {
        contest.whitelabelRektOdds = playedContest.whitelabelRektOdds || 0;
        contest.whitelabelMoonOdds = playedContest.whitelabelMoonOdds || 0;
      }

      const closeTime = Date.parse(contest.contestCloseTime);
      const liveTime = Date.parse(contest.contestLiveTime);

      if (closeTime <= now && contest.status === "Live") {
        contest.status = "Closing";
      } else if (liveTime <= now && contest.status === "Opened") {
        contest.status = "Live";
      }

      if (!contest.livePrice && lastPrice?.ts === liveTime) {
        contest.livePrice = lastPrice?.price;
        contest.livePriceTime = Date.now();
      }

      if (!contest.closePrice && lastPrice?.ts === closeTime) {
        contest.closePrice = lastPrice?.price;
        contest.closePriceTime = Date.now();
      }
      return {
        ...playedContest,
        ...contest,
      };
    })
    .filter((c) => c?.seriesId === seriesID)
    .sort(
      (a, b) => Date.parse(a.contestLiveTime) - Date.parse(b.contestLiveTime)
    );
};

export const getClosingContest = createSelector(
  getSelectedDuration,
  getSelectedCoin,
  (state) => state?.coinPrices?.lastPrices,
  (state) => contestsFromRoot(state),
  (selectedDuration, selectedCoin, lastPrices, contestSeries) => {
    const contests = getSortedContests(
      selectedDuration,
      selectedCoin,
      lastPrices,
      contestSeries
    );

    const liveIndex = contests.findIndex((item) => {
      return item?.status === "Live";
    });
    const result =
      liveIndex >= 0
        ? contests[liveIndex - 1]
        : contests.findLast((c) => ["Closing", "Closed"].includes(c.status));

    return result;
  }
);

export const getContestsCarousel = createSelector(
  getSelectedDuration,
  getSelectedCoin,
  (state) => state?.coinPrices?.lastPrices,
  (state) => contestsFromRoot(state),
  (state) => state?.coinPrices?.BTC,
  (selectedDuration, selectedCoin, lastPrices, contestSeries, BTC) => {
    
    const contests = getSortedContests(
      selectedDuration,
      selectedCoin,
      lastPrices,
      contestSeries
    );
    const result = contests
      .filter((c) => !["Closing", "Closed", "Expired"].includes(c.status))
      .slice(0, 5);

    if (result[1]) {
      result[1].status = "Opened";
    }
    if (result[2]) {
      result[2].status = "Opened";
    }

    return result;
  }
);

export const getContestsCarouselLive = createSelector(
  getSelectedDuration,
  getSelectedCoin,
  (state) => state?.coinPrices?.lastPrices,
  (state) => contestsFromRoot(state),
  (selectedDuration, selectedCoin, lastPrices, contestSeries) => {
    const contests = getSortedContests(
      selectedDuration,
      selectedCoin,
      lastPrices,
      contestSeries
    );
    return contests.filter((c) => ["Live"].includes(c.status)).slice(0, 1);
  }
);
